import { PageAction } from './../models/page-config';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AfterViewInit, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { DynamicFormComponent } from '../dynamic-form/dynamic-form.component';
import { BaseService } from 'src/app/core/services/base.service';

@Component({
  selector: 'app-generic-scanner-dialog',
  templateUrl: './generic-scanner-dialog.component.html',
  styleUrls: ['./generic-scanner-dialog.component.scss']
})
export class GenericScannerDialogComponent implements OnInit, AfterViewInit {
  @ViewChild(DynamicFormComponent) dynamicFormComponent;

  apiCallInProgress: boolean = false;
  dialogConfig: any;
  formConfig: any;
  scannerConfig: any;


  constructor(
    private baseService: BaseService,
    private dialogRef: MatDialogRef<GenericScannerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    console.log('data: ', data);
    this.dialogConfig = data.dialogConfig;
    this.formConfig = data.formConfig;
    this.scannerConfig = data.scannerConfig;

  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    // Set the contextData of the scanner to the form value
    this.scannerConfig.contextData = this.dynamicFormComponent? this.dynamicFormComponent?.form.getRawValue() : this.formConfig?.initialFormValue;
  }

  disableForm() {
    this.dynamicFormComponent?.form?.disable();
  }

}